import { Box, Link, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

const ChatHistoryHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <h3>Chat History</h3>
      <ul>
        <li>Items are saved across sessions</li>
        <li>Bulk operations available</li>
        <li>Price calculations in real-time</li>
      </ul>
    </Box>
    <Box>
      <h3>Need Help?</h3>
      <Link href="#" external>
        Contact customer support
      </Link>
    </Box>
  </SpaceBetween>
);

export default ChatHistoryHelpPanel;
